<template>
  <div class="ReportDataMater-gray">
    <div class="dr-left">
      <div class="dr-user">
        <div class="dr-user-head" :class="User.Sex == 1 ? 'dr-head-man' : 'dr-head-woman'"></div>
        <div class="dr-user-info">
          <div>姓名：
            {{User.RealName.length > 10 ? User.RealName.substring(0, 10) + '....' : User.RealName}}
            <p> {{$t('original.account') + '：' + (User.UserID.length > 12? User.UserID.substring(0, 12) + '....' : User.UserID)}}
            </p>
          </div>
          <div>{{ User.DeptName }}</div>
        </div>
      </div>
      <div class="dr-option">
        <div class="dr-row" v-for="(item, index) in ActiveMenuList" :key="index">
          <el-button class="dr-button" type="success" :class="ActiveButton == item.MenuID ? 'dr-bt-select' : ''" @click="gotoFunc(item, index)">
            {{ item.MenuName }}
          </el-button>
        </div>
      </div>
    </div>
    
    <div class="dr-right">
      <div class="dr-tool" v-if="IsShowOption">
        <el-button type="primary" v-for="(item, index) in ActiveMenuList[ActiveIndex].ButtonList" :key="index" :title="item.BtnHint" @click="OptionClick(item)"
          :class="item.State == true ? 'option-active' : 'option-noactive'">
          {{ item.BtnName }}
        </el-button>
        <el-button type="primary" title="返回" style="float: right; margin-top: 10px;" @click="GoToBack">
          返回
        </el-button>
      </div>
      <UserBasic ref="UserBasic" v-if="ActiveButton == 'DataReport_UserBasic'" :ID="TRPUserID" @init="InitData" @fatherSetOption="SetOptionState" />
      <RPUserList ref="RPUserList" v-if="ActiveButton == 'DataReport_HeartTalk' || ActiveButton == 'DataReport_PsyTalk' || ActiveButton == 'DataReport_TalkEval'
      " :ID="TRPUserID" @fatherSetOption="SetOptionState" @SingleButton="SetSingleButton" />
      <RPUserArchives ref="UserArchives" v-if="ActiveButton == 'DataReport_ExportInfo'" :ID="TRPUserID" />
    </div>
  </div>
</template>
<script>
import UserBasic from './RPUserInfo';
import RPUserList from './RPTableUserList';
import RPUserArchives from './RPUserArchives';
export default {
  data() {
    return {
      IsShowOption: true,
      MenuID: '',
      ShowCheck: true,
      ActiveIndex: 0,
      ActiveMenuList: [{ ButtonList: [] }],
      ActiveButton: 'DataReport_UserBasic',
      TRPUserID: '',
      UserID: '',
      User: { RealName: '', UserID: '' },
      UserTableConfig: {},
      optionState: 0, //1表示初始状态
      optionList: [], //需要操作的记录集合，例如删除记录
    };
  },
  components: {
    UserBasic,
    RPUserList,
    RPUserArchives,
  },
  created() {
  },
  methods: {
    InitData: function () {
      let _this = this;
      this.$Http_Post('ReportCriData/GetUserDetail', {
        UserID: _this.UserID,
        TRPUserID: _this.TRPUserID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.User = res.Data.User;
          _this.UserTableConfig = res.Data.TableConfig;
          setTimeout(() => {
            this.$refs.UserBasic.SetUserInfo(
              { UserBasic: _this.User, TableConfig: _this.UserTableConfig },
              {
                OptionState: _this.optionState,
                UserID: _this.UserID,
                ID: _this.TRPUserID,
                TableCngID: 'UserExtendInfo',
                ModuleID: _this.ActiveButton,
              }
            );
          }, 500)
        } else {
          this.Global.request_failure('获取信息失败');
        }
      });
    },
    
    SetSingleButton: function (obj) {
      if (obj.Name == 'btnRemove') {
        for (
          let i = 0;
          i < this.ActiveMenuList[this.ActiveIndex].ButtonList.length;
          i++
        ) {
          if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnRemove'
          )


            this.$set(this.ActiveMenuList[this.ActiveIndex].ButtonList[i], 'State', obj.Value);

            
        }
      }
    },
    SetOptionState: function (state) {
      this.optionState = state;
      if (this.$refs.UserBasic) this.$refs.UserBasic.SetOption(state);
      for (
        let i = 0;
        i < this.ActiveMenuList[this.ActiveIndex].ButtonList.length;
        i++
      ) {
        if (state == 1) {
          if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnModify'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnSave'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnCancel'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnAdd'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnRemove'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnExport'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
        } else if (state == 2) {
          if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnModify'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnSave'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnCancel'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnAdd'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnRemove'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnExport'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
        } else {
          if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnModify'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnSave'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnCancel'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnAdd'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnRemove'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              false
            );
          else if (
            this.ActiveMenuList[this.ActiveIndex].ButtonList[i].BtnCode ==
            'btnExport'
          )
            this.$set(
              this.ActiveMenuList[this.ActiveIndex].ButtonList[i],
              'State',
              true
            );
        }
      }
    },
    GoToBack: function () {
      this.$router.go(-1);
    },
    SaveData() {
      if (this.ActiveButton == 'DataReport_UserBasic')
        this.$refs.UserBasic.SavaUserData();
    },
    gotoFunc: function (item, idx) {
      this.ActiveButton = item.MenuID;
      this.ActiveIndex = idx;
      let _this = this;
      setTimeout(() => {
        if (_this.ActiveButton == 'DataReport_UserBasic')
          _this.$refs.UserBasic.SetUserInfo(
            { UserBasic: _this.User, TableConfig: _this.UserTableConfig },
            {
              OptionState: _this.optionState,
              UserID: _this.UserID,
              ID: _this.TRPUserID,
              TableCngID: 'UserExtendInfo',
              ModuleID: _this.ActiveButton,
            }
          );
        else if (
          _this.ActiveButton == 'DataReport_HeartTalk' ||
          _this.ActiveButton == 'DataReport_PsyTalk' ||
          _this.ActiveButton == 'DataReport_TalkEval'
        )
          _this.$refs.RPUserList.SetTableConfig({
            UserID: _this.UserID,
            TableConfigID:
              item.ForeignID == undefined || item.ForeignID == null
                ? _this.ActiveButton
                : item.ForeignID,
            ID: _this.TRPUserID,
            ModuleID: _this.ActiveButton,
            ShowCheck: _this.ShowCheck,
          });
        else if (_this.ActiveButton == 'DataReport_ExportInfo') {
          _this.$refs.UserArchives.SetUserInfo(
            {
              UserID: _this.UserID,
            },
            {
              OptionState: _this.optionState,
              UserID: _this.UserID,
              ID: _this.TRPUserID,
              TableCngID: 'UserExtendInfo',
              ModuleID: _this.ActiveButton,
            }
          );
        }
        _this.SetOptionState(0);
      }, 200);
    },
    OptionClick: function (item) {
      if (item.BtnCode == 'btnAdd' && item.State == true) {
        if (item.State) this.$refs.RPUserList.DoMyAdd();
        this.SetOptionState(2);
      } else if (item.BtnCode == 'btnModify' && item.State == true) {
        this.SetOptionState(1);
        if (this.ActiveButton == 'DataReport_UserBasic')
          this.$refs.UserBasic.SetOption(1);
        else this.$refs.RPUserList.DoMyModify();
      } else if (item.BtnCode == 'btnSave' && item.State == true)
        this.SaveData();
      else if (item.BtnCode == 'btnCancel' && item.State == true)
        this.SetOptionState(0);
      else if (item.BtnCode == 'btnRemove' && item.State == true) {
        this.$refs.RPUserList.DoMyRemove();
      } else if (item.BtnCode == 'btnExport' && item.State == true) {
        this.$refs.UserArchives.DoMyExport();
      }
    },
  },
  mounted() {
    this.MenuID = this.$route.query.MenuID;
    this.TRPUserID = this.$route.query.TRPUserID;
    this.UserID = this.$route.query.UserID;
    let con = this.$route.query.Control;
    if (con == -2) this.ShowCheck = false;
    let _this = this;
    this.$Http_Post('ReportCriData/GetChildMenuList', {
      MenuID: _this.MenuID,
    }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        _this.ActiveMenuList = res.Data;
        _this.ActiveButton = _this.ActiveMenuList[0].MenuID;
        _this.ActiveIndex = 0;
        _this.SetOptionState(0);
        _this.InitData();
      } else {
        this.Global.request_failure('获取信息失败');
      }
    });
  },
};
</script>
<style>
.dr-left {
  float: left;
  width: 20%;
  height: calc(100% - 20px);
  margin: 10px 0px 10px 10px;
  background-color: white;
}

.dr-right {
  float: right;
  width: calc(80% - 30px);
  height: calc(100% - 20px);
  margin: 10px 10px 10px 0px;
  background-color: white;
}

.dr-user {
  height: 25%;
  background-image: url('../../assets/img/ReportData/user-bg.png');
  background-size: 100% 100%;
  position: relative;
}

.dr-user-head {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-left: 20px;
  position: absolute;
  top: 50%;
  margin-top: -40px;
  background-size: 100% 100%;
}

.dr-head-man {
  background-image: url('../../assets/img/ReportData/boy.png');
}

.dr-head-woman {
  background-image: url('../../assets/img/ReportData/girl.png');
}

.dr-user-info {
  position: absolute;
  top: 50%;
  margin-top: -60px;
  margin-left: 120px;
  line-height: 30px;
  width: calc(100% - 125px);
  word-break: break-all;
}

.dr-option {
  height: 50%;
  margin-top: 10px;
}

.dr-tool {
  height: 60px;
  line-height: 60px;
  padding: 0px 10px;
  border-bottom: 5px solid #e7e7e7;
}

.dr-row {
  text-align: center;
  margin-top: 20px;
}

.dr-button {
  width: 80%;
  margin: 10px auto;
}

.dr-button:hover {
  background-color: #087b8c;
  border: 1px solid #087b8c;
}

.dr-bt-select {
  background-color: #087b8c;
  border: 1px solid #087b8c;
}

.el-button--success:focus,
.el-button--success:hover {
  background: #087b8c !important;
  border-color: #087b8c !important;
}

.item-header {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  font-size: 18px;
  background-color: rgb(31, 98, 156);
  color: white;
  padding-left: 20px;
}

.item-content {
  width: 100%;
  border-collapse: collapse;
}

.item-content tr {
  height: 35px;
  line-height: 35px;
}

.item-content td {
  border: 1px solid #e7e7e7;
}

.item-content tr:nth-child(2n) {
  background-color: #f8f6f6;
}

.option-noactive {
  background-color: #96c5f5 !important;
  border: 1px solid #96c5f5 !important;
}
</style>
